<template>
  <div>
    <page-header :header="`${type} Page`">
      <router-link
        v-if="id && currentPage && currentPage.published"
        :to="`/marketing-pack/${currentPage.slug}`"
        class="inline-block no-underline bg-white text-black rounded-lg p-4 uppercase text-sm font-medium align-bottom"
      >
        <i class="far fa-eye fa-fw fa-lg mr-1"></i>
        Preview
      </router-link>
    </page-header>

    <div class="mb-6 -mt-2 pb-4 border-b-4">
      <div class="flex flex-wrap items-center -mx-4">
        <div class="px-4 w-full lg:w-2/3">
          <p class="mb-1">Page title and intro text:</p>
          <input v-model="currentPage.title" type="text" name="title" id="title" placeholder="Title" class="input w-full mb-3 bg-white" :class="{ 'border-red-dark': this.errorBag.get('title') }">
          <input v-model="currentPage.intro" type="text" name="subtitle" id="subtitle" placeholder="Subtitle" class="input w-full mb-3 bg-white">
        </div>
        <div class="px-4 w-full lg:w-1/3">
          <div class="mb-1 flex justify-between items-baseline">
            <p>Menu location:</p>
            <button class="shadow-none" @click="isManagingMenus = true">
              <small>Manage Menus</small>
            </button>
          </div>
          <pl-select v-model="currentPage.menu_id" name="filter_menu" id="filter_menu" class="w-full mb-3" :select-class="['bg-white', { 'border-red-dark': this.errorBag.get('menu_id') }]">
            <option :value="null" disabled>Please Select</option>
            <template v-for="menu in menus">
              <option :key="menu.id" :value="menu.id">{{ menu.name }}</option>
              <option
                v-for="childMenu in menu.children"
                :key="childMenu.id"
                :value="childMenu.id"
              >↳ {{ childMenu.name }}</option>
            </template>
          </pl-select>

          <div class="flex-col items-center mb-3">
            <div class="text-left w-full py-5 mb-3">
              <input id="published" class="leading-tight" type="checkbox" v-model="currentPage.published">
              <label for="published">
                <span class="text-sm">
                  Publish
                </span>
              </label>
            </div>
          <div class="flex flex-col items-center">
            <button @click="savePage" :disabled="isSaving" class="bg-tertiary text-white rounded px-4 py-3 uppercase text-sm font-medium align-bottom ml-auto w-full">
              <i v-if="isSaving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
              <div v-else>
                <i class="far fa-save fa-fw fa-lg" />
                Save Page
              </div>
            </button>
          </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap items-center pt-2" v-if="system.networks && system.networks.length > 1">
        <p class="w-full mb-2">Choose Network:</p>
        <div class="xl:flex-row md:flex md:flex-row sm:flex-col space-between">
          <div v-for="(network, i) in system.networks" :key="i" class="text-sm uppercase">
            <input  type="radio"  :id="+i" name="network.id" :value="network.id" v-model="currentPage.assigned_network">
            <label  :for="+i" class="ml-4 mt-2">{{ network.name }}</label>
          </div>
          <input  type="radio" id="all" name="network.id"  :value="null" v-model="currentPage.assigned_network">
          <label  for="all"  class="ml-4 mt-2">ALL</label>
        </div>
      </div>
    </div>

    <div class="mb-6 -mt-2 pb-4 border-b-4">
      <div class="flex -mx-4">
        <div class="px-4 w-full">
          <p class="mb-1">Page Type:</p>
          <pl-select v-model="currentPage.product_config.page_type" class="w-full my-2" :select-class="['bg-white', { 'border-red-dark': this.errorBag.get('product_config.page_type') }]">
            <option value="new-order">New Order</option>
            <option value="order-history">Order History</option>
          </pl-select>
        </div>
      </div>
    </div>

    <div class="mb-6 -mt-2 pb-4 border-b-4" v-if="currentPage.product_config.page_type === 'new-order'">
      <div class="flex -mx-4">
        <div class="px-4 w-full">
          <h3 class="mb-5">Page Options</h3>
          <div>
            <label class="mb-2 block" for="product_heading">Heading</label>
            <input v-model="currentPage.product_config.heading" type="text" id="product_heading" class="input w-full mb-3 bg-white" :class="{ 'border-red-dark': this.errorBag.get('product_config.heading') }">

            <label class="mb-2 block" for="product_intro">Introduction Paragraph</label>
            <textarea
              rows="5"
              id="product_intro"
              class="w-full input bg-white mb-6"
              v-model="currentPage.product_config.intro"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-6 -mx-4 flex flex-wrap">
      <div class="w-full lg:w-2/3 px-4">
        <div class="bg-white rounded-lg p-6 pt-0 mt-12">
          <div class="flex flex-wrap items-center border-b mb-6 pb-2">
            <page-icon-picker
              :icon="currentPage.icon"
              :color="currentPage.icon_color"
              @change="iconSelected"
            />
          </div>
        </div>
      </div>
    </div>

    <modal
      height="90vh"
      width="70vw"
      v-if="mediaManagerVisible"
    >
      <media-manager
        @selected="selectMedia($event)"
        @closeMediaManager="mediaManagerVisible = false"
      />
    </modal>
  </div>
</template>

<script>
import DeletionModal from '@/components/Modals/DeletionModal'
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import { find } from 'lodash'
import { mapState, mapMutations, mapActions } from 'vuex'
import PageIconPicker from '@/components/cms/PageIconPicker'
import MediaManager from '@/components/MediaManager'

export default {
  components: { PageIconPicker, DeletionModal, MediaManager },
  props: ['id'],
  created () {
    this.loadPage()
  },
  watch: {
    pages () {
      this.loadPage()
    }
  },
  data () {
    return {
      isSaving: false,
      isManagingMenus: false,
      mediaManagerVisible: false,
      mediaManagerStyle: null,
      mediaManagerType: null,
      errorBag: new ErrorBag(),
      currentPage: {
        assigned_network: null,
        slug: 'marketing-pack/new-order',
        title: null,
        intro: null,
        type: 'marketing-pack',
        published: false,
        icon: null,
        partner_options: {},
        video_url: null,
        page_turner_url: null,
        website_url: null,
        content: [],
        modules: [],
        product_module: null,
        product_config: {
          page_type: 'new-order',
          heading: '',
          intro: ''
        }
      }
    }
  },
  computed: {
    ...mapState([
      'pages', 'menus', 'system'
    ]),
    type () {
      return this.id ? 'Edit Marketing Pack Page' : 'Create New Marketing Pack Page'
    }
  },
  methods: {
    ...mapMutations([
      'setPage'
    ]),
    ...mapActions([
      'displayToastNotification'
    ]),
    iconSelected (data) {
      this.currentPage.icon = data.icon
      this.currentPage.icon_color = data.color
    },
    loadPage () {
      if (this.id && this.pages && this.pages.length > 0) {
        this.currentPage = find(this.pages, p => p.slug === this.id)
      }
    },
    handleSaveError (error) {
      this.errorBag.store(error.response.data)
      this.isSaving = false
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-bell',
        title: 'Unable to save page',
        info: error.response.data.message
      })
    },
    handleSaveSuccess (response) {
      this.setPage(response.data)
      this.isSaving = false
      this.displayToastNotification({
        type: 'success',
        icon: 'fa-check',
        title: 'Page Saved',
        info: `Page "${this.currentPage.title}" has been successfully saved.`
      })
    },
    saveAndPreview () {
      this.savePage()
      this.$router.push(`/${this.currentPage.slug}`)
    },
    savePage () {
      this.isSaving = true
      this.errorBag.clear()
      if (this.id) {
        api.patch(`pages/${this.id}`, this.currentPage)
          .then(response => {
            this.handleSaveSuccess(response)
          })
          .catch(error => {
            this.handleSaveError(error)
          })
      } else {
        api.post(`pages`, this.currentPage)
          .then(response => {
            this.handleSaveSuccess(response)
            this.$router.back()
          })
          .catch(error => {
            this.handleSaveError(error)
          })
      }
    },
    selectMedia (media) {
      if (this.mediaManagerType === 'images') {
        this.currentPage.product_config.style[this.mediaManagerStyle].images.push(media.path)
      } else {
        this.currentPage.product_config.style[this.mediaManagerStyle][this.mediaManagerType] = media.path
      }
      this.mediaManagerVisible = false
    },
    openMediaManager (style, type) {
      this.mediaManagerStyle = style
      this.mediaManagerType = type
      this.mediaManagerVisible = true
    },
    deleteImage (style, image) {
      const index = this.currentPage.product_config.style[style].images.indexOf(image)
      this.currentPage.product_config.style[style].images.splice(index, 1)
    }
  }
}
</script>
